import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=32338a5c&scoped=true&"
import script from "./Education.vue?vue&type=script&lang=ts&"
export * from "./Education.vue?vue&type=script&lang=ts&"
import style0 from "./Education.vue?vue&type=style&index=0&id=32338a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32338a5c",
  null
  
)

component.options.__file = "Education.vue"
export default component.exports